import React, { Fragment } from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { configs } from '../../../constants/configs/configs';
import { normalizeFileSize } from '../../../utils/normalizeFileSize.utils';
import { formatDateToTimezone, guessTimeZone } from '../../../utils/dates/date.utils';
import { DESC_FORMAT_11 } from '../../../utils/dates/dateFormats.utils';

const UploadedFileList = props => {
    const { attachments, openDeleteAttachmentPopup } = props;
    const intl = useIntl();
    const zone_name = guessTimeZone();

    const openAttachment = (path, e) => {
        e.preventDefault();
        const docpath = window.encodeURI(path);
        const url = configs.endpoints.VIEW_ATTACHMENT_URL + docpath;
        window.open(
            url,
            '_blank',
            'directories=no, status=no, menubar=no, scrollbars=yes, resizable=no,width=600, height=280,top=200,left=200',
        );
    };

    return (
        <Fragment>
            {attachments.map((ticket, index) => {
                return (
                    <div className="grid-row row-file" key={index}>
                        <div className="mobile:grid-col-12 desktop:grid-col-6">
                            <a href="" onClick={e => openAttachment(ticket.encDocPath, e)}>
                                {ticket.fileName}
                            </a>
                        </div>
                        <div className="mobile:grid-col-12 desktop:grid-col-2">{normalizeFileSize(ticket.size)}</div>
                        <div className="mobile:grid-col-12 desktop:grid-col-3">
                            {formatDateToTimezone(ticket.date, zone_name, DESC_FORMAT_11)}
                        </div>
                        {ticket.deleteAllowed ? (
                            <div className="mobile:grid-col-12 desktop:grid-col-1">
                                <i
                                    title={intl.formatMessage({ id: 'ticket.attachment.button.delete.attachment' })}
                                    className="icon-link"
                                    onClick={e => openDeleteAttachmentPopup(ticket.docPath)}
                                >
                                    <FontAwesomeIcon icon="trash-alt" size="1x" />
                                </i>
                            </div>
                        ) : null}
                    </div>
                );
            })}
        </Fragment>
    );
};

export default UploadedFileList;
